import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StyleButton from './StyleButton';

const BLOCK_TYPES = [
  { label: 'Blockquote', style: 'blockquote', icon: '/assets/img/icons/editor/quote.svg' },
  { label: 'UL', style: 'unordered-list-item', icon: '/assets/img/icons/editor/ul.svg' },
  { label: 'OL', style: 'ordered-list-item', icon: '/assets/img/icons/editor/ol.svg' },
  { label: 'HTML', style: 'code-block', icon: '/assets/img/icons/editor/html.svg'},
];

export default class BlockStyleControls extends Component {
  render() {
    const { editorState } = this.props;
    const selection = editorState.getSelection();
    const blockType = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();

    return (
      <div className="entry-editor-controls">
        {BLOCK_TYPES.map(type =>
          <StyleButton
            key={type.label}
            active={type.style === blockType}
            label={type.label}
            icon={type.icon}
            onToggle={this.props.onToggle}
            style={type.style}
          />,
        )}
      </div>
    );
  }
}

BlockStyleControls.propTypes = {
  onToggle: PropTypes.func.isRequired,
  editorState: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/cms/form/editor/BlockStyleControls.js